import styled from 'styled-components';
import Btn022 from 'dc/Btn022';

export const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
`;

export const Button = styled(Btn022)`
  align-self: flex-start;
  padding: 24px 0;
  span {
    text-transform: none;
  }
`;
